export enum EndpointConstants {
  ValidateOpm = '/validate/opm',
  CalculatePwerm = '/calculate/pwerm',
  CalculatePwermInputs = '/calculate/pwerm-inputs',
  CalculateBenchmarkingInputs = '/calculate/benchmarking-inputs',
  CalculateCapitalStructure = '/calculate/capitalstructure',
  CalculateBuildStructure = '/calculate/buildstructure',
  CalculateOpmInputs = '/calculate/opm-inputs',
  OpmResults = '/results',
}
